import React from 'react'
import {Section} from '../styles/AboutStyles'
import {Title} from '../styles/AchievementsStyle'
import {

  PropertiesContainer,
  PropertyCard,
  ImageWrapper,
  PropertyImage,
  Badge,
  CardBody,
  PropertyLink,
  Address,
  Features,
  FeatureSeparator,
  Price,
} from '../styles/FeaturedPropertiesStyles'


const properties= [
    {
      id: 1,
      image: "/assets/images/fe1.jpg",
      badge: "For Sale",
      title: "3910 Berryman Ave",
      address: "3910 Berryman Ave, Los Angeles, CA, 90066",
      features: {
        bedrooms: "4BD",
        bathrooms: "5BA",
        area: "2,608 Sq.Ft."
      },
      price: "$2,750,000"
    },
    {
      id: 2,
      image: "/assets/images/fe2.jpg",
      badge: "For Rent",
      title: "125 Ocean Blvd",
      address: "125 Ocean Blvd, Miami, FL, 33139",
      features: {
        bedrooms: "3BD",
        bathrooms: "2BA",
        area: "1,850 Sq.Ft."
      },
      price: "$3,500/month"
    },
    {
      id: 3,
      image: "/assets/images/fe3.jpg",
      badge: "Sold",
      title: "7825 Elmwood Ave",
      address: "7825 Elmwood Ave, Dallas, TX, 75235",
      features: {
        bedrooms: "5BD",
        bathrooms: "4BA",
        area: "3,200 Sq.Ft."
      },
      price: "$1,850,000"
    }
  ]
  

const FeaturedProperties = () => {
  return (
    <Section>
      <Title>Featured Properties</Title>
      <PropertiesContainer>
        {properties.map((property) => (
          <PropertyCard key={property.id}>
            <ImageWrapper>
              <PropertyImage src={property.image} alt={property.title} />
              <Badge>{property.badge}</Badge>
            </ImageWrapper>
            <CardBody>
              <PropertyLink href="#home">
                <h3>{property.title}</h3>
              </PropertyLink>
              <Address>{property.address}</Address>
              <Features>
                {property.features.bedrooms} | 
                <FeatureSeparator>{property.features.bathrooms}</FeatureSeparator> | 
                <FeatureSeparator>{property.features.area}</FeatureSeparator>
              </Features>
              <Price>{property.price}</Price>
            </CardBody>
          </PropertyCard>
        ))}
      </PropertiesContainer>
    </Section>
  )
}

export default FeaturedProperties